@use "../../sass/global/global" as *;

.ux-iws-data-controller-product-overview {
    display: block;

    *[data-ux-product-hidden] {
        display: none;
    }

    *[slot="counter"] {
        @include font(light);
        font-size: 18px;
        color: $color-gray-text;
        padding: 0 15px;

        @media only screen and (min-width: 568px) {
            padding: 0 30px;
        }
    }
}
